import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useNewMembershipPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
      },
    },
    sidepanel: {
      paddingTop: '29px',
      paddingLeft: '34px',
      width: '310px',
      [theme.breakpoints.down('sm')]: {
        width: 'auto',
        '& svg': {
          width: '56px',
          height: '56px',
        },
      },
    },
  })
);
